import type { CatalogRepository } from '#/domain/catalog/CatalogRepository'
import type {
  ApplyFireriskMetricPresetOptions,
  FireriskMetricPresetResult,
} from '#/domain/catalog/FireriskMetricPreset'

export class ApplyFireriskMetricPresetUseCase {
  constructor(private readonly repository: CatalogRepository) {}

  async execute(
    organizationId: string,
    options: ApplyFireriskMetricPresetOptions,
  ): Promise<FireriskMetricPresetResult> {
    return this.repository.applyFireriskMetricPreset(organizationId, options)
  }
}
